// import base from "../../../common/base";
export default {
  reactiveVar: (state) => state.reactiveVar,
  shukkaZumiAnkenItems: (state) => state.shukkaZumiAnkenItems,
  commentItems: (state) => state.commentItems,
};
